import { useEffect, useRef, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Progress } from '@/components/ui/progress';

/** Erwartete Generierungsdauer — Basis für den zeitgesteuerten Fortschrittsbalken. */
export const EXPECTED_GEN_MS = 60_000;

/**
 * Fortschrittsbalken-Overlay für laufende Generierungen: animiert in ~60 s
 * Richtung 90 % und bleibt dort, bis die Generierung wirklich fertig ist.
 * Bei Abschluss wird das Overlay vom Ergebnis ersetzt (visuell: Sprung auf 100 %).
 * Absolut positioniert — der Parent braucht `relative`.
 */
export const TimedProgress: React.FC<{ label: string }> = ({ label }) => {
  const [pct, setPct] = useState(3);
  const startRef = useRef(Date.now());
  useEffect(() => {
    const id = window.setInterval(() => {
      const elapsed = Date.now() - startRef.current;
      setPct(Math.min(90, 3 + (elapsed / EXPECTED_GEN_MS) * 87));
    }, 400);
    return () => window.clearInterval(id);
  }, []);
  return (
    <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2.5 bg-black/50 px-6">
      <Loader2 className="h-5 w-5 animate-spin text-white" />
      <Progress value={pct} className="h-1.5 w-full max-w-[220px]" />
      <span className="text-xs font-medium text-white">{label}</span>
    </div>
  );
};
